import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (color, ring) => L.divIcon({
  className: "",
  html: `<div style="width:14px;height:14px;background:${color};border:3px solid #000;border-radius:50%;box-shadow:0 0 0 4px ${ring}"></div>`,
  iconSize: [14, 14], iconAnchor: [7, 7],
});

// Small confirmation map of the chosen pickup/drop-off with the driving route.
export const MapPreview = ({ pickup, dropoff }) => {
  const el = useRef(null);
  const map = useRef(null);
  const layers = useRef([]);

  useEffect(() => {
    if (!el.current) return;
    if (!map.current) {
      map.current = L.map(el.current, { zoomControl: false, attributionControl: false, dragging: true, scrollWheelZoom: false })
        .setView([43.6532, -79.3832], 11);
      L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", { maxZoom: 19 }).addTo(map.current);
    }
    layers.current.forEach((l) => l.remove());
    layers.current = [];

    const pts = [];
    if (pickup) {
      const m = L.marker([pickup.lat, pickup.lng], { icon: pin("#D4AF37", "rgba(212,175,55,0.35)") }).addTo(map.current);
      layers.current.push(m); pts.push([pickup.lat, pickup.lng]);
    }
    if (dropoff) {
      const m = L.marker([dropoff.lat, dropoff.lng], { icon: pin("#ffffff", "rgba(255,255,255,0.25)") }).addTo(map.current);
      layers.current.push(m); pts.push([dropoff.lat, dropoff.lng]);
    }

    setTimeout(() => map.current && map.current.invalidateSize(), 150);

    if (pickup && dropoff) {
      let cancelled = false;
      fetch(`https://router.project-osrm.org/route/v1/driving/${pickup.lng},${pickup.lat};${dropoff.lng},${dropoff.lat}?overview=full&geometries=geojson`)
        .then((r) => r.json())
        .then((j) => {
          if (cancelled || !map.current) return;
          const route = j.routes && j.routes[0];
          if (route) {
            const line = L.polyline(route.geometry.coordinates.map(([x, y]) => [y, x]), { color: "#D4AF37", weight: 3, opacity: 0.85 }).addTo(map.current);
            layers.current.push(line);
            map.current.fitBounds(line.getBounds(), { padding: [25, 25], maxZoom: 14 });
          } else {
            map.current.fitBounds(pts, { padding: [40, 40], maxZoom: 14 });
          }
        })
        .catch(() => map.current && map.current.fitBounds(pts, { padding: [40, 40], maxZoom: 14 }));
      return () => { cancelled = true; };
    } else if (pts.length === 1) {
      map.current.setView(pts[0], 14);
    }
  }, [pickup, dropoff]);

  return <div ref={el} className="w-full h-40 border border-gold/25 isolate relative z-0" data-testid="map-preview" />;
};
